import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import SystemAdminUsersListPage from './system-admin-users-list'

const systemAdminRoutes: Route[] = [
  {
    path: Paths.SYSTEM_ADMIN_USERS_LIST_PAGE,
    element: <SystemAdminUsersListPage />,
    roles: [RoleEnum.SYSTEM_ADMIN]
  }
]

export default systemAdminRoutes
